exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.svg-icon[data-v-019a596c]{vertical-align:-0.15em;fill:currentColor;overflow:hidden\n}\n", "", {"version":3,"sources":["/opt/fh-web/firmiana-hpc-website-main/src/components/svgIcons/index.vue"],"names":[],"mappings":";AACA,2BAA2B,uBAAuB,kBAAkB,eAAe;CAClF","file":"index.vue","sourcesContent":["\n.svg-icon[data-v-019a596c]{vertical-align:-0.15em;fill:currentColor;overflow:hidden\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-019a596c","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/svgIcons/index.vue
// module id = 6uja
// module chunks = 148